module.exports = __webpack_public_path__ + "static/media/artboard1.45a0c9d1.svg";